// src/features/Setting/Melting_Requests/components/MeltingRequests.js
import React, { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { Box } from "@mui/material";
import DynamicTable from "components/ui/TableComponents/DynamicTable";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import { SettingContext } from "context/SettingContext";
import { useInView } from "react-intersection-observer";
import CollectionDiscriptionModal from "features/collection/components/Modal/CollectionDiscriptionModal";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useMeltingRequestInfinite } from "../API/meltingrequestapi";
import { formatDateAndTime } from "utils/formatDateAndTime";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const MeltingRequest = () => {
  // Contexts
  const { setSelectedSortValue, selectedSortValue } = useContext(SortContext);

  const { setSearchPlaceHolder, sortOptions, setFilterChangeCount, setDisplayCount, setSearchResultCount, dynamicfilterCount, setDynamicFilterCount, filterChangeCount , setMeltingStatus} = useGlobalContext();

  // Hooks
  const { ref, inView } = useInView();
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [remarkData, setRemarkData] = useState({
    collectionDiscription: "",
    styleNumber: "",
    meltingRequestId: "",
  });
  const { setSyncButtonName, setSyncButton, search, setSearch, searchBar, setSearchBar } = useContext(SettingContext);

  // Derived state
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);

  //API call
  const { data, isLoading, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage, error } = useMeltingRequestInfinite({
    page: 1,
    limit: 15,
    sortBy: selectedOption?.value || "",
    order: selectedOption?.order || "asc",
    searchBy: search,
    status: "",
  });
  //  console.log("data====>>>",data)

  // Method 1: Direct access
  const MeltingRequestData =
    data?.pages.flatMap((page) => {
      // The page itself contains the array items
      // Check if page is array-like
      if (Array.isArray(page)) {
        return page;
      }

      // Otherwise, look for array properties
      const arrays = Object.values(page).filter((val) => Array.isArray(val));
      return arrays.flat();
    }) || [];

  const totalCount = useMemo(() => data?.pages[0]?.totalCount || 0, [data]);

  console.log({ data });

  //console.log("Melting Requests Array:", MeltingRequestData);

  // Handlers
  const handleRemarkViewClick = useCallback((remark, row) => {
    setRemarkData({
      collectionDiscription: remark,
      styleNumber: `#${row.formatMeltingRequestId}`,
    });
    setSelectedRowData(row);
    setOpenRemarkModal(true);
  }, []);

  const handleCloseRemarkModal = useCallback(() => {
    setOpenRemarkModal(false);
  }, []);

  const handleViewClick = (data) => {
    // console.log("data====>>>",data);
    const requestId = data._id;
    const newState = {
      ...location.state,
      name: [location?.state?.name[0], `#${data?.formatMeltingRequestId}`],
      status: data?.statusTimeline,
      // name: [`${location?.state?.name[0]?.split(" - ")[0]}`,, `#${data?.formatMeltingRequestId}`],
    };
    console.log("New State====>", newState);
    setMeltingStatus(data?.statusTimeline);

    navigate(`/Setting/melting-requests/${requestId}`, { state: newState });
  };

  //   const handleViewClick = (data) => {

  //   const requestId = data._id;

  //   const newState = {
  //     ...location.state,
  //     requestStatus: {
  //       ...location.state?.requestStatus,
  //       [requestId]: data.statusTimeline || "pending",
  //     },
  //     name: [...(location.state?.name || []), `#${data.formatMeltingRequestId}`],
  //   };

  //   navigate(`/Setting/melting-requests/${requestId}`, { state: newState });
  // };

  const headers = [
    { label: "Sr. No", width: "50px", style: { gap: "5px", padding: "10px" } },
    { label: "User Name", width: "204px", style: { gap: "10px", padding: "10px" } },
    { label: "Date & Time", width: "156px", style: { gap: "8px", padding: "10px" } },
    { label: "Melting Request ID", width: "149px", style: { gap: "10px", padding: "10px" } },
    { label: "Quantity", width: "86px", style: { gap: "10px", padding: "10px" } },
    { label: "Diamond Wt", width: "129px", style: { gap: "10px", paddingRight: "10px", paddingLeft: "10px" } },
    { label: "Gold Wt", width: "112px", style: { gap: "10px", padding: "10px" } },
    { label: "Status", width: "140px", style: { gap: "10px", paddingTop: "10px", paddingRight: "20px", paddingBottom: "10px", paddingLeft: "20px" } },
    { label: "Remark", style: { padding: "10px" } },
    { label: "View", width: "60px" },
  ];
  const getStatusStyle = (status) => {
    const statusText = status || "Pending";
    const styles = {
      Pending: {
        backgroundColor: "rgba(255, 215, 0, 0.15)",
        color: "rgba(255, 215, 0, 1)",
      },
      Rejected: {
        backgroundColor: "rgba(231, 123, 123, 0.15)",
        color: "rgba(231, 123, 123, 1)",
      },
      Completed: {
        backgroundColor: "rgba(66, 135, 245, 0.15)",
        color: "rgba(66, 135, 245, 1)",
      },
      Approved: {
        backgroundColor: "rgba(46, 125, 50, 0.15)",
        color: "rgba(46, 125, 50, 1)",
      },
      Finalise: {
        backgroundColor: "rgba(66, 149, 197, 0.15)",
        color: "rgba(68, 165, 245, 1)",
      },
    };

    return {
      ...(styles[statusText] || {
        backgroundColor: "rgba(226, 227, 229, 0.15)",
        color: "rgba(56, 61, 65, 1)",
      }),
      border: "none",
      fontFamily: "Poppins",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "100%",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100px",
      height: "28px",
      borderRadius: "6px",
    };
  };

  const permission=usePermissions();
const hasViewActions = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Melting Request"), "view");
  // Table configuration

  // Prepare table sections
  const sections = [
    {
      headers,
      rows: MeltingRequestData.map((row, rowIndex) => {
        const statusStyle = getStatusStyle(row.statusTimeline);

        return [
          // Sr. No
          <div key={`${row.id}-1`} style={{ gap: "5px", padding: "10px" }}>
            {rowIndex + 1}
          </div>,

          // User Name
          <div key={`${row.id}-2`} style={{ gap: "10px", padding: "10px" }}>
            {row.createMeltingRequestUserRef}
          </div>,

          // Date & Time
          <div key={`${row.id}-3`} style={{ gap: "8px", padding: "10px" }}>
            {formatDateAndTime(row.createdAt)}
          </div>,

          // Melting Request ID
          <div key={`${row.id}-4`} style={{ gap: "10px", padding: "10px", fontWeight: "500" }}>
            {row.formatMeltingRequestId}
          </div>,

          // Quantity
          <div key={`${row.id}-5`} style={{ gap: "10px", padding: "10px" }}>
            {row.meltingStockJewelCount}
          </div>,

          // Diamond Wt
          <div key={`${row.id}-6`} style={{ gap: "10px", paddingRight: "10px", paddingLeft: "10px" }}>
            {row.totalDiaWt}
          </div>,

          // Gold Wt
          <div key={`${row.id}-7`} style={{ gap: "10px", padding: "10px" }}>
            {row.totalNetWt}
          </div>,

          // Status
          <div
            key={`${row.id}-8`}
            style={{
              width: "140px",
              height: "44px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              padding: "10px 20px",
              boxSizing: "border-box",
              margin: "0px auto",
            }}
          >
            <div style={statusStyle}>{row.statusTimeline}</div>
          </div>,

          // Remark with view icon
          <div
            key={`${row.id}-9`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "10px",
              height: "44px",
              boxSizing: "border-box",
              overflow: "hidden",
              flex: 1,
            }}
          >
            <div
              style={{
                flex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: "Karla",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "22px",
                letterSpacing: "-0.41px",
                color: "#ffffff",
                textAlign: "left",
                maxWidth: "120px",
                paddingRight: "5px",
              }}
            >
              {row.remark}
            </div>

            <Box
              onClick={() => handleRemarkViewClick(row.remark, row)}
              sx={{
                color: "#fff",
                padding: "4px",
                minWidth: "24px",
                minHeight: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "4px",
                },
              }}
            >
              <VisibilityOutlinedIcon sx={{ fontSize: "15px" }} />
            </Box>
          </div>,

          // View Action
          <div
            key={`${row.id}-10`}
            style={{
              width: "60px",
              height: "44px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxSizing: "border-box",
              margin: "0px auto",
            }}
          >
            <Box
              onClick={() => hasViewActions && handleViewClick(row)}
              sx={{
                color: "#fff",
                padding: "4px",
                minWidth: "24px",
                minHeight: "24px",
                cursor: hasViewActions ? "pointer" : "default",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "4px",
                },
              }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </Box>
          </div>,
        ];
      }),
    },
  ];

  useEffect(() => {
    if (!Array.isArray(MeltingRequestData)) return;

    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(totalCount);
      setSearchResultCount(totalCount);
    } else {
      setSearchResultCount(totalCount);
      setFilterChangeCount(filterChangeCount);
    }
    // if (dynamicfilterCount) {
    //   setFilterChangeCount(MeltingRequestData.length);
    //   setSearchResultCount(MeltingRequestData.length);
    // } else {
    //   setSearchResultCount(MeltingRequestData.length);
    //   setFilterChangeCount(filterChangeCount);
    // }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [MeltingRequestData]);

  //  console.log("meltingRequests====>>>",meltingRequests)

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search by User name or Melting Request ID");

    return () => {
      setSearchBar(false);
      setSearchPlaceHolder("");
    };
  }, [setSearchBar, setSearchPlaceHolder]);

  // Status style function

  return (
    <>
      <div
        style={{
          padding: "10px",
          background: "#000",
          // width: "100%",
          // height: "100%",
          // justifyContent: "flex-end",
          // overflowX: "auto",
        }}
      >
        <DynamicTable sections={sections} loading={isLoading} error={false} maxHeight={"70vh"} isFetchingNextPage={isFetchingNextPage} loadMoreRef={ref} />
      </div>

      <CollectionDiscriptionModal open={openRemarkModal} handleClose={handleCloseRemarkModal} data={remarkData} setData={setRemarkData} />
    </>
  );
};

export default MeltingRequest;